function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor",
  transform: "translate(-585 -442)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(325.5 -249.5)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(259.5 694.5)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M277.741,707.943H261.259a1.75,1.75,0,0,1-1.759-1.737v-9.968a1.751,1.751,0,0,1,1.759-1.738h16.481a1.751,1.751,0,0,1,1.759,1.738v9.968A1.75,1.75,0,0,1,277.741,707.943Zm-16.481-12.459a.766.766,0,0,0-.776.754v9.968a.766.766,0,0,0,.776.754h16.481a.766.766,0,0,0,.776-.754v-9.968a.766.766,0,0,0-.776-.754Z",
  transform: "translate(-259.5 -694.5)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(259.806 695.09)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M270.128,704.562a.491.491,0,0,1-.305-.106l-9.2-7.279a.492.492,0,0,1,.61-.772l8.9,7.038,8.9-7.038a.492.492,0,0,1,.61.772l-9.2,7.279A.491.491,0,0,1,270.128,704.562Z",
  transform: "translate(-260.434 -696.3)"
}))),
/*#__PURE__*/
React.createElement("rect", {
  fill: "none",
  width: 20,
  height: 20,
  transform: "translate(585 442)"
}));

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgEmail, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Email.17392060.svg";
export { ForwardRef as ReactComponent };